import apiClient from './apiClient';

/**
 * Fetch all FAQs for a customer
 */
export const fetchFAQs = async (customerId) => {
    try {
        const response = await apiClient.get(`/api/customers/${customerId}/faq`);
        return response.data;
    } catch (error) {
        console.error('Error fetching FAQs:', error);
        throw error;
    }
};

/**
 * Create a new FAQ
 */
export const createFAQ = async (customerId, faqData) => {
    try {
        const response = await apiClient.post(`/api/customers/${customerId}/faq`, faqData);
        return response.data;
    } catch (error) {
        console.error('Error creating FAQ:', error);
        throw error;
    }
};

/**
 * Update an existing FAQ
 */
export const updateFAQ = async (customerId, faqId, faqData) => {
    try {
        const response = await apiClient.patch(`/api/customers/${customerId}/faq/${faqId}`, faqData);
        return response.data;
    } catch (error) {
        console.error('Error updating FAQ:', error);
        throw error;
    }
};

/**
 * Delete an FAQ
 */
export const deleteFAQ = async (customerId, faqId) => {
    try {
        const response = await apiClient.delete(`/api/customers/${customerId}/faq/${faqId}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting FAQ:', error);
        throw error;
    }
};
